import { ReactNode, Children, ReactFragment, ReactElement } from 'react';

interface DivisibleStackProps {
  wrapper?: string;
  divider?: string;
  children: ReactNode;
}

export const DivisibleStack = (props: DivisibleStackProps) => {
  const { children, divider, wrapper } = props;

  let content: ReturnType<(typeof Children)['toArray']> | ReactNode;

  if (divider) {
    content = Children.toArray(children)
      .filter(Boolean)
      .flatMap((child, index) => {
        if (index === 0) {
          return [child];
        }
        return [divider && <div className={divider} key={`divider-${index}`} />, child];
      });
  } else {
    content = children;
  }

  if (wrapper) {
    return <div className={wrapper}>{content}</div>;
  } else {
    return <>{content}</>;
  }
};
